import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Settings as SettingsIcon, Globe, Shield } from 'lucide-react';
import { UserProfileSettings } from '@/components/admin/UserProfileSettings';

const Settings = () => {
  const settingsSections = [
    {
      title: 'Site Settings',
      description: 'Configure your site title, description, and general settings',
      icon: Globe,
      items: ['Site title', 'Site description', 'Site URL', 'Timezone']
    },
    {
      title: 'Security',
      description: 'Manage security settings and permissions',
      icon: Shield,
      items: ['Password', 'Two-factor authentication', 'Login sessions', 'API keys']
    }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Settings</h1>
        <p className="text-muted-foreground">Configure your CMS settings</p>
      </div>

      {/* User Profile Settings - Functional */}
      <UserProfileSettings />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {settingsSections.filter(section => section.title !== 'User Profile').map((section, index) => (
          <Card key={index}>
            <CardHeader>
              <CardTitle className="flex items-center">
                <section.icon className="h-5 w-5 mr-2" />
                {section.title}
              </CardTitle>
              <CardDescription>{section.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 mb-4">
                {section.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="text-sm text-muted-foreground">
                    • {item}
                  </li>
                ))}
              </ul>
              <Button variant="outline" size="sm">
                <SettingsIcon className="h-3 w-3 mr-2" />
                Configure
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Coming Soon Notice */}
      <Card>
        <CardHeader>
          <CardTitle>Settings Panel</CardTitle>
          <CardDescription>
            Full settings management will be implemented in the next phase
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-8 text-muted-foreground">
            <SettingsIcon className="h-12 w-12 mx-auto mb-4 opacity-50" />
            <p>Advanced settings configuration coming soon</p>
            <p className="text-sm">Including SEO settings, social media integration, and more</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Settings;